import React from 'react'

export default function PaddingRight({ color = '', style = {} }) {
    let fillColor = '#7246B1'
    if (color) fillColor = color
    let className = 'icons-icon'
    return (
        <svg
            className={className}
            style={style}
            xmlns='http://www.w3.org/2000/svg'
            width='20'
            height='20'
            viewBox='0 0 20 20'
            fill='none'
        >
            <path
                d='M7 3L10 3C11.1046 3 12 3.89543 12 5L12 15C12 16.1046 11.1046 17 10 17L7 17'
                stroke={color}
                strokeWidth='1.25'
                strokeLinecap='round'
            />
            <path d='M9 7L9 13' stroke={color} strokeWidth='1.25' strokeLinecap='round' />
        </svg>
    )
}
